import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0C1F49',
                secondary: '#E8E2D3',
            }
        }
        
    }
});